import { controlClose } from '../../../../resources/scripts/components/c-common';

export default function () {
  const roomsWrapper = window.document.querySelector('.js-rooms-wrapper');

  if (!roomsWrapper) {
    return;
  }

  const control = roomsWrapper.closest('.js-control');
  const controlContainer = control?.querySelector('.js-control-container');
  const controlTrigger = control?.querySelector('.js-control-trigger');
  const roomsComponent = roomsWrapper.closest('.js-rooms');
  const roomTemplate = roomsWrapper.querySelector('.js-rooms-room').cloneNode(true);
  const adultsInput = roomsWrapper.querySelector('.js-room-adults');
  const decreaseAdultsButton = roomsWrapper.querySelector('.js-room-guests-button[data-action="decrease"][data-guest="adults"]');
  const clearButton = roomsComponent?.querySelector('.js-rooms-clear');
  const saveButton = roomsComponent?.querySelector('.js-rooms-save');
  const focusInput = () => adultsInput?.focus();

  const closeRoomControl = () => {
    controlClose(control);
    controlContainer?.classList.remove('open');
    controlTrigger?.focus();
  };

  function handleFocusOrder(element, { onTab, onShiftTab, shouldHandle }) {
    if (!element) {
      return;
    }

    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') {
        return;
      }

      const allowed = shouldHandle ? shouldHandle(event) : true;
      if (!allowed) {
        return;
      }

      if (event.shiftKey && onShiftTab) {
        event.preventDefault();
        onShiftTab();
        return;
      }

      if (!event.shiftKey && onTab) {
        event.preventDefault();
        onTab();
      }
    });
  }

  if (controlTrigger) {
    controlTrigger.addEventListener('click', () => {
      setTimeout(() => {
        focusInput();
      }, 0);
    });
  }

  handleFocusOrder(decreaseAdultsButton, {
    onShiftTab: () => {
      const removeButton = roomsComponent.querySelector('.js-rooms-remove');
      if (removeButton) {
        removeButton.focus();
        return;
      }

      if (clearButton?.classList.contains('show')) {
        clearButton.focus();
        return;
      }

      closeRoomControl();
    },
  });
  handleFocusOrder(clearButton, { onShiftTab: closeRoomControl });
  handleFocusOrder(saveButton, { onTab: closeRoomControl });

  let totalGuests = 1;
  let totalRooms = 1;

  function roomsFooterUpdate() {
    const rooms = roomsWrapper.querySelectorAll('.js-rooms-room');
    rooms.forEach((room, index) => {
      const elementFooter = window.document.createElement('div');
      elementFooter.classList.add('c-rooms__guests');
      elementFooter.classList.add('c-rooms__guests--footer');
      elementFooter.classList.add('js-rooms-room-footer');

      const textForTitle = room.dataset.i18nTitle;
      const elementTitle = window.document.createElement('div');
      elementTitle.classList.add('c-rooms__room-number');
      elementTitle.textContent = `${textForTitle} ${index + 1}`;

      const textForRemove = room.dataset.i18nRemove;
      const elementRemove = window.document.createElement('button');
      elementRemove.classList.add('c-rooms__button');
      elementRemove.classList.add('c-rooms__button--remove');
      elementRemove.classList.add('js-rooms-remove');
      elementRemove.textContent = `${textForRemove}`;

      elementFooter.append(elementTitle);

      if (rooms.length > 1) {
        elementFooter.append(elementRemove);
      }

      const elementFooterExisting = room.querySelector('.js-rooms-room-footer');
      if (elementFooterExisting) {
        elementFooterExisting.remove();
      }

      room.prepend(elementFooter);
    });
  }

  function roomsSummaryUpdate() {
    const rooms = roomsWrapper.querySelectorAll('.js-rooms-room');
    const elementSummaryRooms = window.document.querySelector('.js-rooms-summary-rooms');
    elementSummaryRooms.textContent = `${rooms.length} ${rooms.length > 1 ? elementSummaryRooms.dataset.i18nRooms : elementSummaryRooms.dataset.i18nRoom}`;
    totalRooms = rooms.length;
  }

  function guestsSummaryUpdate() {
    const guests = roomsWrapper.querySelectorAll('.js-control-input');
    const elementSummaryGuests = window.document.querySelector('.js-rooms-summary-guests');
    let count = 0;

    guests.forEach((guest) => {
      count += parseInt(guest.value, 10);
    });

    totalGuests = count;

    elementSummaryGuests.textContent = `${count} ${count > 1 ? elementSummaryGuests.dataset.i18nGuests : elementSummaryGuests.dataset.i18nGuest}`;

    const button = window.document.querySelector('.js-rooms-clear');
    if (totalGuests > 1) {
      button.classList.add('show');
    } else {
      button.classList.remove('show');
    }
  }

  function guestsNumberUpdate(event, action) {
    const MIN = 0;
    const MAX = 6;
    const { target } = event;
    const inputWrapper = target.closest('.js-control-input-wrapper');
    const elementInput = inputWrapper.querySelector('.js-control-input');

    if (action === 'increase' && elementInput.value < MAX) {
      elementInput.value = Number(elementInput.value) + 1;
    }

    if (action === 'decrease' && elementInput.value > MIN) {
      elementInput.value = Number(elementInput.value) - 1;
    }
  }

  function updateChildrenAges(room) {
    const wrapper = room.querySelector('.js-room-ages');
    const children = wrapper.querySelectorAll('.js-room-age');

    children.forEach((child, index) => {
      const label = child.querySelector('.js-room-children-age-label');
      const template = label.dataset.i18nLabel;
      label.textContent = template.replace('%s', index + 1);
    });
  }

  function agesAdd(room) {
    const wrapper = room.querySelector('.js-room-ages');
    const ages = wrapper.querySelectorAll('.js-room-age');
    const original = ages[0];

    if (ages.length < 6) {
      if (original.classList.contains('hidden')) {
        original.classList.remove('hidden');
      } else {
        const clone = original.cloneNode(true);
        const childrenAge = clone.querySelector('.js-room-children-age');
        childrenAge.classList.remove('error');
        wrapper.append(clone);
        updateChildrenAges(room);
      }
    }
  }

  function agesRemove(room) {
    const wrapper = room.querySelector('.js-room-ages');
    const ages = wrapper.querySelectorAll('.js-room-age');

    if (ages.length > 1) {
      ages.forEach((age, i) => {
        if (i === ages.length - 1) {
          age.remove();
        }
      });
    } else {
      ages[0].classList.add('hidden');
    }
  }

  function roomAdd() {
    const rooms = roomsWrapper.querySelectorAll('.js-rooms-room');

    if (rooms.length < 6) {
      const clone = roomTemplate.cloneNode(true);

      clone.querySelector('.js-control-adults').value = 1;
      clone.querySelector('.js-control-children').value = 0;

      const ages = clone.querySelectorAll('.js-room-age');
      ages.forEach((age, i) => {
        if (i === 0) {
          age.classList.add('hidden');
        } else {
          age.remove();
        }
      });

      roomsWrapper.appendChild(clone);
    }
  }

  function idsUpdate() {
    const rooms = roomsWrapper.querySelectorAll('.js-rooms-room');
    rooms.forEach((room, i) => {
      const roomAdults = room.querySelector('.js-room-adults');
      const roomAdultsLabel = room.querySelector('.js-room-adults-label');
      roomAdults.id = `c-room-adults-${i}`;
      roomAdultsLabel.setAttribute('for', roomAdults.id);

      const roomChildren = room.querySelector('.js-room-children');
      const roomChildrenLabel = room.querySelector('.js-room-children-label');
      roomChildren.id = `c-room-children-${i}`;
      roomChildrenLabel.setAttribute('for', roomChildren.id);

      const ages = room.querySelectorAll('.js-room-age');
      ages.forEach((age, j) => {
        const childrenAge = age.querySelector('.js-room-children-age');
        const childrenAgeLabel = age.querySelector('.js-room-children-age-label');
        childrenAge.id = `c-room-children-age-${i}-${j}`;
        childrenAgeLabel.setAttribute('for', childrenAge.id);
      });
    });
  }

  function roomRemove(room) {
    room.remove();
  }

  function save() {
    const trigger = control.querySelector('.js-control-trigger');
    const {
      i18nRoom, i18nRooms, i18nGuest, i18nGuests, i18nLabel,
    } = trigger.dataset;

    if (totalRooms === 0) {
      trigger.textContent = i18nLabel;
    } else {
      trigger.textContent = `${totalRooms} ${totalRooms > 1 ? i18nRooms : i18nRoom}, ${totalGuests} ${totalGuests > 1 ? i18nGuests : i18nGuest}`;
    }
  }

  function clear() {
    const trigger = control.querySelector('.js-control-trigger');
    let rooms = control.querySelectorAll('.js-rooms-room');
    const summaryRooms = control.querySelector('.js-rooms-summary-rooms');
    const summaryGuests = control.querySelector('.js-rooms-summary-guests');
    const buttonClear = control.querySelector('.js-rooms-clear');

    buttonClear.classList.remove('show');

    trigger.textContent = trigger.dataset.i18nLabel;
    summaryRooms.textContent = `1 ${summaryRooms.dataset.i18nRoom}`;
    summaryGuests.textContent = `1 ${summaryGuests.dataset.i18nGuests}`;

    if (rooms.length === 0) {
      roomAdd();
      rooms = control.querySelectorAll('.js-rooms-room');
    }

    rooms.forEach((room, i) => {
      if (i > 0) {
        room.remove();
      }

      const ages = room.querySelectorAll('.js-room-age');
      ages.forEach((age, n) => {
        if (n === 0) {
          const label = age.querySelector('.js-room-children-age-label');
          const template = label.dataset.i18nLabel;
          label.textContent = template.replace('%s', '');
          age.classList.add('hidden');
        } else {
          age.remove();
        }
      });
    });

    const adults = rooms[0].querySelector('.js-room-adults');
    const children = rooms[0].querySelector('.js-room-children');
    adults.value = 1;
    children.value = 0;

    roomsFooterUpdate();
    idsUpdate();
  }

  function validate(widget) {
    let validated = true;
    const rooms = widget.querySelectorAll('.js-rooms-room');
    rooms.forEach((room) => {
      const ages = room.querySelectorAll('.js-room-children-age');

      ages.forEach((age) => {
        age.classList.remove('error');
      });

      ages.forEach((age) => {
        const wrapper = age.closest('.js-room-age');
        if (age.value === '' && !wrapper.classList.contains('hidden')) {
          age.classList.add('error');
          validated = false;
        }
      });
    });
    return validated;
  }

  window.addEventListener('change', (event) => {
    const { target } = event;
    if (target.value === '') {
      target.classList.add('error');
    } else {
      target.classList.remove('error');
    }
  });

  window.addEventListener('mousedown', (event) => {
    const { target } = event;
    if (target.classList.contains('js-rooms-remove')) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  window.addEventListener('click', (event) => {
    const { target } = event;

    // add room
    if (target.classList?.contains('js-rooms-add')) {
      event.preventDefault();
      roomAdd();
      roomsFooterUpdate();
      roomsSummaryUpdate();
      guestsSummaryUpdate();
      idsUpdate();
    }

    // remove room
    if (target.classList?.contains('js-rooms-remove')) {
      event.preventDefault();
      event.stopPropagation();
      const room = target.closest('.js-rooms-room');
      roomRemove(room);
      roomsFooterUpdate();
      roomsSummaryUpdate();
      guestsSummaryUpdate();
    }

    // increase/decrease number of guests
    if (target.classList?.contains('js-room-guests-button')) {
      event.preventDefault();
      const { action } = target.dataset;
      guestsNumberUpdate(event, action);
      roomsSummaryUpdate();
      guestsSummaryUpdate();
    }

    if (target.classList?.contains('js-room-children-button')) {
      event.preventDefault();
      const { action } = target.dataset;
      const room = target.closest('.js-rooms-room');

      if (action === 'increase') {
        agesAdd(room);
        idsUpdate();
      }

      if (action === 'decrease') {
        agesRemove(room);
        idsUpdate();
      }
    }

    // save
    if (target.classList?.contains('js-rooms-save')) {
      event.preventDefault();
      const widget = target.closest('.js-booking-widget');
      if (validate(widget) === true) {
        save();
        closeRoomControl();
        roomsSummaryUpdate();
        guestsSummaryUpdate();
      }
    }

    // clear
    if (target.classList?.contains('js-rooms-clear')) {
      event.preventDefault();
      clear();
      roomsSummaryUpdate();
      guestsSummaryUpdate();
      setTimeout(() => {
        closeRoomControl();
      }, 0);
    }
  });

  let ignoreRoomsControlFocusout = false;

  if (controlContainer) {
    controlContainer.addEventListener('mousedown', () => {
      ignoreRoomsControlFocusout = true;
      window.setTimeout(() => {
        ignoreRoomsControlFocusout = false;
      }, 0);
    });

    controlContainer.addEventListener('focusout', (event) => {
      const next = event.relatedTarget;
      if (next instanceof Node && controlContainer.contains(next)) {
        return;
      }

      if (ignoreRoomsControlFocusout) {
        return;
      }

      window.setTimeout(() => {
        const focused = document.activeElement;
        if (!focused || controlContainer.contains(focused)) {
          return;
        }

        if (control) {
          controlClose(control);
        }
      }, 0);
    });
  }

  roomsFooterUpdate();
  roomsSummaryUpdate();
  guestsSummaryUpdate();
  idsUpdate();
}
